// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── page wrapper ────────────────────────────────────────── */
.au-page {
  height: 100vh;
  width: 100vw;
  background: radial-gradient(circle at top left, rgba(42, 113, 255, 0.12), transparent 26%),
    linear-gradient(180deg, #eef4ff 0%, #e7eefb 52%, #dde8f7 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
  font-family: "Inter", "Segoe UI", sans-serif;
}

@media (min-width: 1024px) {
  .au-page {
    padding: 24px;
  }
}

/* ── outer container ─────────────────────────────────────── */
.au-outer {
  background: rgba(255, 255, 255, 0.6);
  border-radius: 34px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0 30px 100px rgba(59, 130, 246, 0.12);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  width: 100%;
  max-width: 1480px;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* ── top bar ─────────────────────────────────────────────── */
.au-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-bottom: 1px solid rgba(203, 213, 225, 0.7);
  flex-shrink: 0;
}

@media (min-width: 1024px) {
  .au-topbar {
    padding: 16px 32px;
  }
}

.au-topbar-logo {
  height: 36px;
  width: auto;
  object-fit: contain;
}

@media (min-width: 1024px) {
  .au-topbar-logo {
    height: 40px;
  }
}

.au-topbar-badge {
  display: none;
  align-items: center;
  gap: 0;
  border: 1px solid #dbeafe;
  color: #2a71ff;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.18em;
  padding: 4px 12px;
  border-radius: 9999px;
  background-color: #eff6ff;
}

@media (min-width: 1024px) {
  .au-topbar-badge {
    display: inline-flex;
  }
}

/* ── two-panel row ───────────────────────────────────────── */
.au-panels {
  display: grid;
  gap: 16px;
  flex: 1;
  min-height: 0;
  padding: 16px;
  overflow: hidden;
}

@media (min-width: 1024px) {
  .au-panels {
    grid-template-columns: 0.9fr 1.1fr;
    padding: 24px;
  }
}

/* ── left panel ──────────────────────────────────────────── */
.au-left {
  background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);
  border-radius: 30px;
  border: 1px solid #e2e8f0;
  padding: 24px;
  box-shadow: 0 18px 56px rgba(15, 23, 42, 0.06);
  display: flex;
  flex-direction: column;
  gap: 0;
  min-width: 0;
  overflow-y: auto;
}

.au-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 0 16px;
  height: 44px;
  font-size: 14px;
  font-weight: 700;
  color: #334155;
  cursor: pointer;
  width: fit-content;
  transition:
    border-color 0.15s,
    color 0.15s;
}

.au-back-btn:hover {
  border-color: #cbd5e1;
  color: #0f172a;
}

.au-section-tag {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.2em;
  color: #2a71ff;
  margin: 32px 0 0 0;
}

.au-left-title {
  font-size: 2.25rem;
  font-weight: 700;
  color: #0f172a;
  margin: 12px 0 0 0;
  line-height: 1.1;
  letter-spacing: -0.02em;
}

.au-left-desc {
  font-size: 15px;
  color: #475569;
  line-height: 1.75;
  margin: 16px 0 0 0;
  max-width: 32rem;
}

/* ── session info card ───────────────────────────────────── */
.au-info-card {
  border: 1px solid #e2e8f0;
  border-radius: 28px;
  padding: 20px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.au-info-top {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 12px;
}

@media (min-width: 480px) {
  .au-info-top {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
}

.au-info-top-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.au-info-top-badges {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.au-info-icon {
  width: 48px;
  height: 48px;
  border-radius: 16px;
  background: #2a71ff;
  box-shadow: 0 8px 24px rgba(42, 113, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.au-info-terminal {
  font-size: 14px;
  font-weight: 900;
  color: #0f172a;
  margin: 0 0 2px 0;
}

.au-info-sub {
  font-size: 13px;
  color: #64748b;
  margin: 0;
}

.au-badge-location {
  border: 1px solid #bfdbfe;
  background: rgba(239, 246, 255, 0.5);
  color: #2563eb;
  font-size: 13px;
  font-weight: 700;
  padding: 6px 16px;
  border-radius: 9999px;
}

.au-badge-org {
  border: 1px solid #a7f3d0;
  background: rgba(236, 253, 245, 0.5);
  color: #059669;
  font-size: 13px;
  font-weight: 700;
  padding: 6px 16px;
  border-radius: 9999px;
}

.au-info-bottom {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 4px;
}

.au-info-stat {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 22px;
  padding: 16px;
}

.au-info-stat.green {
  background: #ecfdf5;
  border-color: #a7f3d0;
}

.au-info-stat-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.16em;
  color: #2a71ff;
  margin: 0 0 8px 0;
}

.au-info-stat.green .au-info-stat-label {
  color: #059669;
}

.au-info-stat-value {
  font-size: 14px;
  font-weight: 900;
  color: #0f172a;
  margin: 0;
}

/* ── bottom action buttons ───────────────────────────────── */
.au-bottom-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: auto;
  padding-top: 24px;
}

.au-action-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  height: 34px;
  padding: 0 14px;
  border-radius: 30px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  border: 1.5px solid;
  transition: background 0.15s;
}

.au-action-btn.location {
  background: #f0f5ff;
  border-color: #c5d4f0;
  color: #4a72b5;
}

.au-action-btn.location:hover {
  background: #e3ecff;
}

.au-action-btn.logout {
  background: #fff5f5;
  border-color: #fecaca;
  color: #dc2626;
}

.au-action-btn.logout:hover {
  background: #fee2e2;
}

/* ── right panel ─────────────────────────────────────────── */
.au-right {
  background: #fff;
  border-radius: 30px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 18px 56px rgba(15, 23, 42, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow-y: auto;
}

/* ── form card inside right panel ───────────────────────── */
.au-form-card {
  width: 100%;
  max-width: 620px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid #e2e8f0;
  border-radius: 32px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

@media (min-width: 1024px) {
  .au-form-card {
    padding: 32px;
  }
}

.au-right-section-tag {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.2em;
  color: #2a71ff;
  margin: 0;
}

.au-right-title {
  font-size: 1.875rem;
  font-weight: 700;
  color: #0f172a;
  margin: 12px 0 0 0;
  letter-spacing: -0.02em;
  line-height: 1.1;
}

/* ── form fields ─────────────────────────────────────────── */
.au-fields {
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ── form labels ─────────────────────────────────────────── */
.au-field-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.2em;
  color: #94a3b8;
  margin: 0 0 8px 0;
}

/* ── input wrapper ───────────────────────────────────────── */
.au-input-wrap {
  display: flex;
  align-items: center;
  border: 1px solid #e2e8f0;
  border-radius: 24px;
  padding: 0 16px;
  height: 56px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  transition:
    border-color 0.15s,
    box-shadow 0.15s;
}

.au-input-wrap:focus-within {
  border-color: #bfdbfe;
  box-shadow: 0 0 0 3px rgba(42, 113, 255, 0.08);
}

.au-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
  background: transparent;
  min-width: 0;
}

.au-input::placeholder {
  color: #94a3b8;
  font-weight: 400;
}

.au-eye-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  color: #94a3b8;
  display: flex;
  align-items: center;
  transition: color 0.15s;
}

.au-eye-btn:hover {
  color: #64748b;
}

/* ── custom dropdown ─────────────────────────────────────── */
.au-dropdown-wrap {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e2e8f0;
  border-radius: 24px;
  padding: 0 16px;
  height: 56px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  cursor: pointer;
  transition: border-color 0.15s;
  user-select: none;
}

.au-dropdown-wrap:hover {
  border-color: #bfdbfe;
}

.au-dropdown-value {
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
}

.au-dropdown-value.placeholder {
  color: #94a3b8;
  font-weight: 400;
}

.au-dropdown-arrow {
  color: #94a3b8;
  font-size: 20px !important;
  transition: transform 0.15s;
}

.au-dropdown-arrow.open {
  transform: rotate(180deg);
}

.au-dropdown-list {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(15, 23, 42, 0.1);
  z-index: 100;
  overflow-y: auto;
  max-height: 230px;
}

.au-dropdown-list::-webkit-scrollbar {
  width: 6px;
}

.au-dropdown-list::-webkit-scrollbar-track {
  background: transparent;
}

.au-dropdown-list::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  border-radius: 10px;
}

.au-dropdown-list::-webkit-scrollbar-thumb:hover {
  background-color: #94a3b8;
}
.au-dropdown-list {
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.au-dropdown-item {
  padding: 14px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #1e293b;
  cursor: pointer;
  transition: background 0.1s;
}

.au-dropdown-item:hover {
  background: #f0f5ff;
}

.au-dropdown-item.empty {
  color: #94a3b8;
  cursor: default;
}

/* ── submit button ───────────────────────────────────────── */
.au-submit-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 56px;
  background: #2a71ff;
  border: none;
  border-radius: 24px;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  margin-top: 32px;
  box-shadow: 0 22px 50px rgba(42, 113, 255, 0.35);
  transition:
    background 0.15s,
    opacity 0.15s,
    box-shadow 0.15s;
}

.au-submit-btn:hover:not(:disabled) {
  background: #155eef;
  box-shadow: 0 16px 40px rgba(42, 113, 255, 0.4);
}

.au-submit-btn:disabled {
  background: #cbd5e1;
  color: #94a3b8;
  cursor: not-allowed;
  box-shadow: none;
}

/* ── responsive ──────────────────────────────────────────── */
@media (max-width: 700px) {
  .au-page {
    padding: 12px;
  }
  .au-panels {
    grid-template-columns: 1fr;
    overflow-y: auto;
  }
  .au-left,
  .au-right {
    border-radius: 20px;
  }
  .au-left-title {
    font-size: 1.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/sessionPage/components/Authentication/indexV2.css"],"names":[],"mappings":"AAAA,+DAA+D;AAC/D;EACE,aAAa;EACb,YAAY;EACZ;kEACgE;EAChE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,+DAA+D;AAC/D;EACE,oCAAoC;EACpC,mBAAmB;EACnB,0CAA0C;EAC1C,iDAAiD;EACjD,2BAA2B;EAC3B,mCAAmC;EACnC,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,iDAAiD;EACjD,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,SAAS;EACT,OAAO;EACP,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE;IACE,kCAAkC;IAClC,aAAa;EACf;AACF;;AAEA,+DAA+D;AAC/D;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB;;eAEa;AACf;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;EAChC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+DAA+D;AAC/D;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D;EACE,WAAW;EACX,gBAAgB;EAChB,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,+DAA+D;AAC/D;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,yCAAyC;EACzC;;oBAEkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;EACf,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;EAC5C,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gDAAgD;EAChD;;;oBAGkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;EACE;IACE,aAAa;EACf;EACA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;EACA;;IAEE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* ── page wrapper ────────────────────────────────────────── */\n.au-page {\n  height: 100vh;\n  width: 100vw;\n  background: radial-gradient(circle at top left, rgba(42, 113, 255, 0.12), transparent 26%),\n    linear-gradient(180deg, #eef4ff 0%, #e7eefb 52%, #dde8f7 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  box-sizing: border-box;\n  font-family: \"Inter\", \"Segoe UI\", sans-serif;\n}\n\n@media (min-width: 1024px) {\n  .au-page {\n    padding: 24px;\n  }\n}\n\n/* ── outer container ─────────────────────────────────────── */\n.au-outer {\n  background: rgba(255, 255, 255, 0.6);\n  border-radius: 34px;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  box-shadow: 0 30px 100px rgba(59, 130, 246, 0.12);\n  backdrop-filter: blur(24px);\n  -webkit-backdrop-filter: blur(24px);\n  width: 100%;\n  max-width: 1480px;\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n/* ── top bar ─────────────────────────────────────────────── */\n.au-topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 24px;\n  border-bottom: 1px solid rgba(203, 213, 225, 0.7);\n  flex-shrink: 0;\n}\n\n@media (min-width: 1024px) {\n  .au-topbar {\n    padding: 16px 32px;\n  }\n}\n\n.au-topbar-logo {\n  height: 36px;\n  width: auto;\n  object-fit: contain;\n}\n\n@media (min-width: 1024px) {\n  .au-topbar-logo {\n    height: 40px;\n  }\n}\n\n.au-topbar-badge {\n  display: none;\n  align-items: center;\n  gap: 0;\n  border: 1px solid #dbeafe;\n  color: #2a71ff;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.18em;\n  padding: 4px 12px;\n  border-radius: 9999px;\n  background-color: #eff6ff;\n}\n\n@media (min-width: 1024px) {\n  .au-topbar-badge {\n    display: inline-flex;\n  }\n}\n\n/* ── two-panel row ───────────────────────────────────────── */\n.au-panels {\n  display: grid;\n  gap: 16px;\n  flex: 1;\n  min-height: 0;\n  padding: 16px;\n  overflow: hidden;\n}\n\n@media (min-width: 1024px) {\n  .au-panels {\n    grid-template-columns: 0.9fr 1.1fr;\n    padding: 24px;\n  }\n}\n\n/* ── left panel ──────────────────────────────────────────── */\n.au-left {\n  background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);\n  border-radius: 30px;\n  border: 1px solid #e2e8f0;\n  padding: 24px;\n  box-shadow: 0 18px 56px rgba(15, 23, 42, 0.06);\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  min-width: 0;\n  overflow-y: auto;\n}\n\n.au-back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  padding: 0 16px;\n  height: 44px;\n  font-size: 14px;\n  font-weight: 700;\n  color: #334155;\n  cursor: pointer;\n  width: fit-content;\n  transition:\n    border-color 0.15s,\n    color 0.15s;\n}\n\n.au-back-btn:hover {\n  border-color: #cbd5e1;\n  color: #0f172a;\n}\n\n.au-section-tag {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.2em;\n  color: #2a71ff;\n  margin: 32px 0 0 0;\n}\n\n.au-left-title {\n  font-size: 2.25rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 12px 0 0 0;\n  line-height: 1.1;\n  letter-spacing: -0.02em;\n}\n\n.au-left-desc {\n  font-size: 15px;\n  color: #475569;\n  line-height: 1.75;\n  margin: 16px 0 0 0;\n  max-width: 32rem;\n}\n\n/* ── session info card ───────────────────────────────────── */\n.au-info-card {\n  border: 1px solid #e2e8f0;\n  border-radius: 28px;\n  padding: 20px;\n  background: #fff;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  margin-top: 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.au-info-top {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n@media (min-width: 480px) {\n  .au-info-top {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  }\n}\n\n.au-info-top-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.au-info-top-badges {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.au-info-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 16px;\n  background: #2a71ff;\n  box-shadow: 0 8px 24px rgba(42, 113, 255, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.au-info-terminal {\n  font-size: 14px;\n  font-weight: 900;\n  color: #0f172a;\n  margin: 0 0 2px 0;\n}\n\n.au-info-sub {\n  font-size: 13px;\n  color: #64748b;\n  margin: 0;\n}\n\n.au-badge-location {\n  border: 1px solid #bfdbfe;\n  background: rgba(239, 246, 255, 0.5);\n  color: #2563eb;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 6px 16px;\n  border-radius: 9999px;\n}\n\n.au-badge-org {\n  border: 1px solid #a7f3d0;\n  background: rgba(236, 253, 245, 0.5);\n  color: #059669;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 6px 16px;\n  border-radius: 9999px;\n}\n\n.au-info-bottom {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-top: 4px;\n}\n\n.au-info-stat {\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 22px;\n  padding: 16px;\n}\n\n.au-info-stat.green {\n  background: #ecfdf5;\n  border-color: #a7f3d0;\n}\n\n.au-info-stat-label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  color: #2a71ff;\n  margin: 0 0 8px 0;\n}\n\n.au-info-stat.green .au-info-stat-label {\n  color: #059669;\n}\n\n.au-info-stat-value {\n  font-size: 14px;\n  font-weight: 900;\n  color: #0f172a;\n  margin: 0;\n}\n\n/* ── bottom action buttons ───────────────────────────────── */\n.au-bottom-actions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-top: auto;\n  padding-top: 24px;\n}\n\n.au-action-btn {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  height: 34px;\n  padding: 0 14px;\n  border-radius: 30px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  border: 1.5px solid;\n  transition: background 0.15s;\n}\n\n.au-action-btn.location {\n  background: #f0f5ff;\n  border-color: #c5d4f0;\n  color: #4a72b5;\n}\n\n.au-action-btn.location:hover {\n  background: #e3ecff;\n}\n\n.au-action-btn.logout {\n  background: #fff5f5;\n  border-color: #fecaca;\n  color: #dc2626;\n}\n\n.au-action-btn.logout:hover {\n  background: #fee2e2;\n}\n\n/* ── right panel ─────────────────────────────────────────── */\n.au-right {\n  background: #fff;\n  border-radius: 30px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 18px 56px rgba(15, 23, 42, 0.06);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  overflow-y: auto;\n}\n\n/* ── form card inside right panel ───────────────────────── */\n.au-form-card {\n  width: 100%;\n  max-width: 620px;\n  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);\n  border: 1px solid #e2e8f0;\n  border-radius: 32px;\n  padding: 24px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n@media (min-width: 1024px) {\n  .au-form-card {\n    padding: 32px;\n  }\n}\n\n.au-right-section-tag {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.2em;\n  color: #2a71ff;\n  margin: 0;\n}\n\n.au-right-title {\n  font-size: 1.875rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 12px 0 0 0;\n  letter-spacing: -0.02em;\n  line-height: 1.1;\n}\n\n/* ── form fields ─────────────────────────────────────────── */\n.au-fields {\n  margin-top: 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* ── form labels ─────────────────────────────────────────── */\n.au-field-label {\n  display: block;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.2em;\n  color: #94a3b8;\n  margin: 0 0 8px 0;\n}\n\n/* ── input wrapper ───────────────────────────────────────── */\n.au-input-wrap {\n  display: flex;\n  align-items: center;\n  border: 1px solid #e2e8f0;\n  border-radius: 24px;\n  padding: 0 16px;\n  height: 56px;\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n  transition:\n    border-color 0.15s,\n    box-shadow 0.15s;\n}\n\n.au-input-wrap:focus-within {\n  border-color: #bfdbfe;\n  box-shadow: 0 0 0 3px rgba(42, 113, 255, 0.08);\n}\n\n.au-input {\n  flex: 1;\n  border: none;\n  outline: none;\n  font-size: 15px;\n  font-weight: 600;\n  color: #0f172a;\n  background: transparent;\n  min-width: 0;\n}\n\n.au-input::placeholder {\n  color: #94a3b8;\n  font-weight: 400;\n}\n\n.au-eye-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  color: #94a3b8;\n  display: flex;\n  align-items: center;\n  transition: color 0.15s;\n}\n\n.au-eye-btn:hover {\n  color: #64748b;\n}\n\n/* ── custom dropdown ─────────────────────────────────────── */\n.au-dropdown-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid #e2e8f0;\n  border-radius: 24px;\n  padding: 0 16px;\n  height: 56px;\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n  cursor: pointer;\n  transition: border-color 0.15s;\n  user-select: none;\n}\n\n.au-dropdown-wrap:hover {\n  border-color: #bfdbfe;\n}\n\n.au-dropdown-value {\n  font-size: 15px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.au-dropdown-value.placeholder {\n  color: #94a3b8;\n  font-weight: 400;\n}\n\n.au-dropdown-arrow {\n  color: #94a3b8;\n  font-size: 20px !important;\n  transition: transform 0.15s;\n}\n\n.au-dropdown-arrow.open {\n  transform: rotate(180deg);\n}\n\n.au-dropdown-list {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  right: 0;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  box-shadow: 0 8px 32px rgba(15, 23, 42, 0.1);\n  z-index: 100;\n  overflow-y: auto;\n  max-height: 230px;\n}\n\n.au-dropdown-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.au-dropdown-list::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.au-dropdown-list::-webkit-scrollbar-thumb {\n  background-color: #cbd5e1;\n  border-radius: 10px;\n}\n\n.au-dropdown-list::-webkit-scrollbar-thumb:hover {\n  background-color: #94a3b8;\n}\n.au-dropdown-list {\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 transparent;\n}\n\n.au-dropdown-item {\n  padding: 14px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #1e293b;\n  cursor: pointer;\n  transition: background 0.1s;\n}\n\n.au-dropdown-item:hover {\n  background: #f0f5ff;\n}\n\n.au-dropdown-item.empty {\n  color: #94a3b8;\n  cursor: default;\n}\n\n/* ── submit button ───────────────────────────────────────── */\n.au-submit-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  height: 56px;\n  background: #2a71ff;\n  border: none;\n  border-radius: 24px;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n  margin-top: 32px;\n  box-shadow: 0 22px 50px rgba(42, 113, 255, 0.35);\n  transition:\n    background 0.15s,\n    opacity 0.15s,\n    box-shadow 0.15s;\n}\n\n.au-submit-btn:hover:not(:disabled) {\n  background: #155eef;\n  box-shadow: 0 16px 40px rgba(42, 113, 255, 0.4);\n}\n\n.au-submit-btn:disabled {\n  background: #cbd5e1;\n  color: #94a3b8;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n/* ── responsive ──────────────────────────────────────────── */\n@media (max-width: 700px) {\n  .au-page {\n    padding: 12px;\n  }\n  .au-panels {\n    grid-template-columns: 1fr;\n    overflow-y: auto;\n  }\n  .au-left,\n  .au-right {\n    border-radius: 20px;\n  }\n  .au-left-title {\n    font-size: 1.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
